export default "__VITE_ASSET__49gS4e2s__"